module.exports = __webpack_public_path__ + "media/src/pages/GuidedOnboarding/images/filePencilCheckBg-b28ee3b590c2086f33e4e4d49428af36.png";